import { memo } from "react";
import { Handle, Position } from "reactflow";
import { Buildings, ArrowRight } from "@phosphor-icons/react";

function DepartmentNode({ data }) {
  const { name, description, system_touchpoints = [], bottlenecks = [], color = "#002FA7", trainingMode, presentationMode, onSelect } = data;

  return (
    <div
      className={`node-card bg-white border-2 rounded-md shadow-sm min-w-[240px] max-w-[300px] cursor-pointer hover:shadow-lg ${trainingMode ? 'training-highlight relative' : ''} ${presentationMode ? 'scale-110' : ''}`}
      style={{ borderColor: `${color}40` }}
      onClick={onSelect}
      data-testid={`department-node-${data.department_id}`}
    >
      {/* 4-side handles for flexible edge routing */}
      <Handle id="t" type="source"    position={Position.Top}    className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="t-in" type="target" position={Position.Top}    className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="b" type="source"    position={Position.Bottom} className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="b-in" type="target" position={Position.Bottom} className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="l" type="source"    position={Position.Left}   className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="l-in" type="target" position={Position.Left}   className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="r" type="source"    position={Position.Right}  className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      <Handle id="r-in" type="target" position={Position.Right}  className="!w-3 !h-3 !border-2 !border-white" style={{ background: color }} />
      
      <div className="px-4 py-3 border-b border-black/5" style={{ backgroundColor: `${color}10` }}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ backgroundColor: `${color}20` }}>
            <Buildings size={22} weight="bold" style={{ color }} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-base text-foreground">{name}</h3>
          </div>
        </div>
      </div>

      <div className="px-4 py-3">
        {description && <p className="text-xs text-muted-foreground line-clamp-2 mb-3">{description}</p>}
        
        {system_touchpoints.length > 0 && (
          <div className="mb-2">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1">Systems</p>
            <div className="flex flex-wrap gap-1">
              {system_touchpoints.slice(0, 3).map((sys, idx) => (
                <span key={idx} className="inline-flex items-center px-2 py-0.5 rounded bg-secondary text-secondary-foreground text-[10px] font-medium">{sys}</span>
              ))}
              {system_touchpoints.length > 3 && <span className="text-[10px] text-muted-foreground">+{system_touchpoints.length - 3}</span>}
            </div>
          </div>
        )}

        {bottlenecks.length > 0 && (
          <div className="mb-2">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1">Bottlenecks</p>
            <div className="flex flex-wrap gap-1">
              {bottlenecks.slice(0, 2).map((bn, idx) => (
                <span key={idx} className="inline-flex items-center px-2 py-0.5 rounded bg-destructive/10 text-destructive text-[10px] font-medium">{bn}</span>
              ))}
            </div>
          </div>
        )}

        <div className="flex items-center justify-end mt-2 text-xs font-medium" style={{ color }}>
          <span>View Details</span>
          <ArrowRight size={12} className="ml-1" />
        </div>
      </div>
    </div>
  );
}

export default memo(DepartmentNode);
